import React from "react";
import { CRMColors } from "../../../../models/CRMColors";
import { CRMSpacing } from "../../../../models/CRMSpacing";
import { CRMFontSizes } from "../../../../models/CRMFontSizes";
import { THexColor } from "../../../../models/StringLiterals";
import { Background } from "../../../BuildingBlocks/Background";
import { Text } from "../../../BuildingBlocks/Text";

export type TDayPriorityBand = "signoff" | "under_offer" | "other";

type TCRMDayPriorityBandProps = {
    band: TDayPriorityBand;
};

export const dayPriorityBandOf = (row: {
    isSignoff: boolean;
    isUnderOffer: boolean;
}): TDayPriorityBand =>
    row.isSignoff ? "signoff"
    : row.isUnderOffer ? "under_offer"
    : "other";

const bandLabel: Record<TDayPriorityBand, string> = {
    signoff: "Needs sign off",
    under_offer: "Under offer",
    other: "Not yet under offer",
};

const bandBackground: Record<TDayPriorityBand, THexColor> = {
    signoff: CRMColors.HIGHLIGHTS_CALMING_PINK_10,
    under_offer: CRMColors.HIGHLIGHTS_POSITIVE_GREEN_12,
    other: CRMColors.NEUTRAL_12,
};

const bandInk: Record<TDayPriorityBand, THexColor> = {
    signoff: CRMColors.HIGHLIGHTS_CALMING_PINK_0,
    under_offer: CRMColors.HIGHLIGHTS_POSITIVE_GREEN_0,
    other: CRMColors.NEUTRAL_2,
};

export const CRMDayPriorityBand = (props: TCRMDayPriorityBandProps): JSX.Element => (
    <div className="crm-day-priority-band">
        <Background
            color={bandBackground[props.band]}
            padding={`${CRMSpacing.TINY} ${CRMSpacing.MEDIUM}`}
        >
            <Text
                size={CRMFontSizes.X_SMALL}
                weight={700}
                letterSpacing="0.7px"
                color={bandInk[props.band]}
            >
                {bandLabel[props.band].toUpperCase()}
            </Text>
        </Background>
    </div>
);
